export const moneyFormater = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
